import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#fff";
function IFIL({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg viewBox="0 0 100 100" height={size} width={size} fill={color}><rect width={32.48} height={6.09} x={45.94} y={59.13}  rx={1.01} ry={1.01} /><rect width={56.83} height={6.09} x={21.58} y={22.6}  rx={1.01} ry={1.01} /><path  d="M27.67 35.79c0-.56-.45-1.01-1.01-1.01H22.6c-.56 0-1.01.45-1.01 1.01v40.6c0 .56.45 1.01 1.01 1.01h54.8c.56 0 1.01-.45 1.01-1.01v-4.06c0-.56-.45-1.01-1.01-1.01H28.69c-.56 0-1.01-.45-1.01-1.01V35.8z" /><path  d="M33.76 35.79c0-.56.45-1.01 1.01-1.01H77.4c.56 0 1.01.45 1.01 1.01v4.06c0 .56-.45 1.01-1.01 1.01H42.89c-1.68 0-3.04 1.36-3.04 3.04s1.36 3.04 3.04 3.04H77.4c.56 0 1.01.45 1.01 1.01v4.06c0 .56-.45 1.01-1.01 1.01H41.88c-1.12 0-2.03.91-2.03 2.03v9.13c0 .56-.45 1.01-1.01 1.01h-4.06c-.56 0-1.01-.45-1.01-1.01V35.76z" /></Svg>;
}
IFIL.DefaultColor = DefaultColor;
export default IFIL;